import Slide from "@mui/material/Slide";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import useIsMobile from "../../hooks/device/useIsMobile";

interface HideOnScrollProps {
  children?: React.ReactElement<unknown>;
}

function HideOnScroll({ children }: Readonly<HideOnScrollProps>) {
  const isMobile = useIsMobile();
  const trigger = useScrollTrigger();

  if (!isMobile) {
    return <>{children}</>;
  }

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}

export default HideOnScroll;
